module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myclass",
    attrs: {
      "id": "تقبل-الاختلاف-1"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقبل الاختلاف")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "accept-the-difference-1"
    }
  }, [_c('h2', [_vm._v("Accept the Difference")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل رأيت يوماً الذهب يصدأ عندما يرى الألماس!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أم الألماس يتحول إلى الرماد في حال رؤيته للذهب!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إذاً.. هل يجب أن نكتفي بمعدن واحد فقط.. نرتدي الذهب أم الألماس؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمر هكذا تماماً.. عندما ترى شخصاً لا يتطابق كُلياً معك.. يخالفك الرأي.. يختار الشاي بدلاً من قهوتك المرة، يشاهد الأفلام بدلاً من قراءة الكتب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن تتقبل ذك الشخص بالطبع؛ لآنه ليس أنت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثم ستفكر: ماذا سيحدث لو كان الجميع مثلي؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جميعنا نشرب القهوة.. نقرأ الكتب.. نتفق في الآراء، نرتدي نفس الملابس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن يكون هناك شاي، لن تكون هناك أفلام، لن يكون هناك شجار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مُمل أليس كذلك؟ الجميع مُثلك، يرغب ما ترغب به ويكرهون ما تكره،")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن يبقى لك شيء مما تُحب.. سيبقى فقط ما تكره.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دع الأمر كما هو، وتقبل كونك لست البشري الوحيد، تقبل كون هناك من يحبون الشاي ويكرهون مذاق قهوتك.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Have you ever seen Gold turns to rust when it meets Diamond!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Or Diamond turns into ashes when it meets Gold!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("So, should we only have one metal, Gold or Diamond?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("It’s the same thing when you see someone that does not match with you at all, disagree with you, choose the tea instead of your bitter coffee, and watch movies instead of reading books!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("You will not accept that person because it’s not you of course!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Then you will think, what if everyone is just like you?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Everyone will drink coffee, read books, always agree at the same ideas, and wear the same clothes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("There will not be any tea, no movies, and no fights.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Bored, is not? everyone just like you, want what you love and hate what you hate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("There will be no more than the things you love, will only last the things you hate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("So, let the things just the way they are, and accept that you’re not the only human, except that there’s who love tea and hate you bitter coffee taste.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("******")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a10bb7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 93
// module chunks = 0